import { registerPlugin } from '@capacitor/core';

export interface FirebaseAnalyticsPlugin {
  logEvent(options: { name: string; params?: Record<string, unknown> }): Promise<void>;
  setScreen(options: { screenName: string; screenClass?: string }): Promise<void>;
  setUserId(options: { userId: string | null }): Promise<void>;
  setUserProperty(options: { key: string; value: string | null }): Promise<void>;
  setEnabled(options: { enabled: boolean }): Promise<void>;
  isAvailable(): Promise<{ available: boolean }>;
}

/**
 * Native-only. There is no GA4 web stream configured for SoFly, so the web
 * implementation is a no-op rather than a second, half-configured pipeline.
 */
const FirebaseAnalytics = registerPlugin<FirebaseAnalyticsPlugin>('FirebaseAnalytics', {
  web: () =>
    Promise.resolve({
      logEvent: () => Promise.resolve(),
      setScreen: () => Promise.resolve(),
      setUserId: () => Promise.resolve(),
      setUserProperty: () => Promise.resolve(),
      setEnabled: () => Promise.resolve(),
      isAvailable: () => Promise.resolve({ available: false }),
    } as FirebaseAnalyticsPlugin),
});

export { FirebaseAnalytics };
